export default __webpack_public_path__ + "static/logo-36cfcbf0668339d82d95adc91eb2d943.png";